module.exports = __webpack_public_path__ + "static/media/pin.f6897c5e.svg";